import { render } from "./TUsuarios.vue?vue&type=template&id=31b56784&scoped=true"
const script = {}

import "./TUsuarios.vue?vue&type=style&index=0&id=31b56784&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b56784"]])

export default __exports__